import PropTypes from 'prop-types';

export const StatDescriptor = PropTypes.shape({
  key: PropTypes.string.isRequired,
});
